import { TypographyOptions } from '@mui/material-hidden/styles/createTypography';
import { textVariants } from './variants';

export const typography: TypographyOptions = {
  h1: textVariants.titilliumWeb24,
  h5: textVariants.titilliumWeb20,
  ...textVariants,
};
